import React, {useState} from 'react';
import s from '../../../PersonalOffice/MyOrders/MyOrdersPopups/Edit/PopupManagerEdit.module.css';
import {OneContactType} from '../../../types/DeliveryData';
import NewInfoCheckbox from '../../../PersonalOffice/MyOrders/MyOrdersPopups/InfoCheckBox/NewInfoCheckbox';
import styleCart from '../../../PersonalOffice/Cart/Cart.module.css';
import style from '../../../PersonalOffice/MyOrders/MyOrdersPopups/PopupsCommonStyle.module.css';
import SelectSvgSelector from '../../InputSelect/SelectSvgSelector';
import {Field, useFormikContext} from 'formik';
import LightGreenButton from '../../Buttons/LightGreenButton';
import {
	useGetContactsListQuery,
	useCreateContactMutation,
} from '../../../redux/deliveryApi';
import {useTranslation} from 'react-i18next';
import {handleApiCall} from '../../../assets/utils/utils';
import {toast} from 'react-toastify';
import NewContactForm from './components/NewContactForm';

type Props = {
	supplier_id?: number;
};

const ChangeContactSelector: React.FC<Props> = ({supplier_id}) => {
	const {t} = useTranslation();
	const [newContact, setNewContact] = useState(false);
	const {setFieldValue, values} = useFormikContext<any>();

	const {
		data: contactsData,
		isFetching,
		isError,
	} = useGetContactsListQuery(supplier_id?.toString());

	const contactsList = contactsData?.contacts ?? [];

	// Автоматический выбор контакта по имени получателя, если contact_id не установлен
	React.useEffect(() => {
		if (!values.contact_id && values.recipient_name && contactsList.length > 0) {
			const matchingContact = contactsList.find((contact: OneContactType) => {
				const fullName = `${contact.name} ${contact.surname}`.trim();
				return fullName.toLowerCase().includes(values.recipient_name.toLowerCase()) ||
					   values.recipient_name.toLowerCase().includes(contact.name.toLowerCase());
			});
			
			if (matchingContact) {
				setFieldValue('contact_id', matchingContact.id);
			}
		}
	}, [values.contact_id, values.recipient_name, contactsList, setFieldValue]);

	return (
		<>
			<ul className={s.checkboxList}>
				{isFetching ? (
					<li>{t('Завантаження...')}</li>
				) : isError ? (
					<li>{t('Помилка завантаження')}</li>
				) : contactsList.length > 0 ? (
					contactsList.map((contact: OneContactType) => {
						return (
							<li key={contact.id} className={s.checkboxElement}>
								<NewInfoCheckbox
									id={contact.id}
									setFieldValue={setFieldValue}
									valueName={'contact_id'}
									labelTxt={`${contact.name} ${contact?.surname}`}
									values={values}
								/>
							</li>
						);
					})
				) : (
					<li>{t('Контакти не знайдено')}</li>
				)}
			</ul>
			<div className={styleCart.addNewButton}>
				<button
					type={'button'}
					onClick={() => {
						setNewContact(!newContact);
					}}
				>
					{newContact ? '-' : '+'}
					{t('Додати контакт')}
				</button>
			</div>
			{newContact && (
				<NewContactForm
					supplier_id={supplier_id?.toString() ?? ''}
					setNewContact={setNewContact}
				/>
			)}
		</>
	);
};

export default ChangeContactSelector;
